var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162.647,
    height: 69.435,
    viewBox: "0 0 162.647 69.435",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svgGroup",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fontSize: "9pt",
    stroke: "#ffffff",
    strokeWidth: "0.25mm",
    fill: "#ffffff",
    style: {
      stroke: "#ffffff",
      strokeWidth: "0.25mm",
      fill: "#ffffff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 10.254 L 0 0.001 L 56.543 0.001 L 56.543 10.254 L 33.447 10.254 L 33.447 69.434 L 23.096 69.434 L 23.096 10.254 L 0 10.254 Z M 106.104 69.434 L 106.104 0.001 L 142.676 0.001 A 17.506 17.506 0 0 1 148.851 1.073 A 16.349 16.349 0 0 1 151.416 2.295 A 17.48 17.48 0 0 1 157.642 8.448 A 16.349 16.349 0 0 1 159.956 16.644 A 19.481 19.481 0 0 1 159.961 17.09 L 159.961 21.631 A 18.792 18.792 0 0 1 159.55 25.689 Q 158.694 29.558 156.055 31.934 A 16.351 16.351 0 0 1 158.805 34.145 A 12.369 12.369 0 0 1 161.084 37.281 Q 162.439 39.97 162.619 43.815 A 25.783 25.783 0 0 1 162.646 45.02 L 162.646 52.686 A 15.837 15.837 0 0 1 160.327 61.085 A 17.412 17.412 0 0 1 154.102 67.164 Q 150.195 69.434 145.459 69.434 L 106.104 69.434 Z M 116.406 59.131 L 145.557 59.131 A 6.715 6.715 0 0 0 150.391 57.203 Q 152.393 55.274 152.393 52.54 L 152.393 44.874 A 6.299 6.299 0 0 0 150.483 40.278 A 7.906 7.906 0 0 0 150.391 40.186 Q 148.389 38.233 145.508 38.233 L 122.266 38.233 L 122.266 27.979 L 142.676 27.979 A 7.13 7.13 0 0 0 147.632 26.099 A 6.423 6.423 0 0 0 149.121 24.16 A 5.903 5.903 0 0 0 149.707 21.534 L 149.707 17.09 A 6.45 6.45 0 0 0 147.76 12.382 A 8.039 8.039 0 0 0 147.632 12.256 A 6.889 6.889 0 0 0 142.676 10.254 L 116.406 10.254 L 116.406 59.131 Z M 60.449 69.434 L 60.449 59.18 L 72.852 59.18 Q 76.709 59.18 79.443 56.495 A 8.756 8.756 0 0 0 82.177 50.149 A 10.518 10.518 0 0 0 82.178 50.001 L 82.178 0.001 L 92.432 0.001 L 92.432 50.147 A 18.401 18.401 0 0 1 89.795 59.839 Q 87.158 64.21 82.715 66.822 A 19.1 19.1 0 0 1 72.852 69.434 L 60.449 69.434 Z",
    vectorEffect: "non-scaling-stroke"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a884cffaf9f99566328c665ccfe3c9c4.svg";
export { ForwardRef as ReactComponent };